import {
    loadStations, loadAllSensors, loadSensorStations,
    loadOperations, loadOperationSensorStation, loadHourlySummary,
    loadDailySummary, loadMonthlySummary, loadQualities, loadReadingsData, loadCurrentQuota, loadVolume,
    loadOrganizations, loadCurrentQuotaChart, loadQuotas
} from "../../api/telemetry";

import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
    stations: [],
    sensors: [],
    sensorStations: [],
    operations: [],
    operationSensorStations: [],
    hourlySummary: [],
    dailySummary: [],
    monthlySummary: [],
    qualities: [],
    readignsData: [],
    currentQuota: [],
    volume: [],
    volumeSaic: [],
    organizations: [],
    currentQuotaChart: [],
    quotas: [],
};

const mutations = {
    setStations(state, data){
        state.stations = data ? data : [];
    },
    setSensors(state, data){
        state.sensors = data ? data : [];
    },
    setSensorStations(state, data){
        state.sensorStations = data ? data : [];
    },
    setOperations(state, data){
        state.operations = data ? data : [];
    },
    setOperationSensorStation(state, data){
        state.operationSensorStations = data ? data : [];
    },
    setHourlySummary(state, data){
        state.hourlySummary = data ? data : [];
    },
    setDailySummary(state, data){
        state.dailySummary = data ? data : [];
    },
    setMonthlySummary(state, data){
        state.monthlySummary = data ? data : [];
    },
    setQualities(state, data){
        state.qualities = data ? data : [];
    },
    setReadingsData(state, data){
        state.readignsData = data ? data : [];
    },
    setCurrentQuota(state, data){
        state.currentQuota = data ? data : [];
    },
    setVolume(state, data){
        state.volume = data ? data : [];
    },
    setVolumeSaic(state, data){
        state.volumeSaic = data ? data : [];
    },
    setOrganizations(state, data){
        state.organizations = data ? data : [];
    },
    setCurrentQuotaChart(state, data){
        state.currentQuotaChart = data ? data : [];
    },
    setQuotas(state, data){
      state.quotas = data ? data : [];
    },
};

const actions = {
    async loadStations( {commit}, payload ){
        const { organization_ids } = payload;
        try{
            const response = await loadStations({ organization_ids });
            commit('setStations', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações das estações.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setStations', undefined);
        }
    },

    async loadSensors( {commit} ){
        try{
            const response = await loadAllSensors();
            commit('setSensors', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações dos sensores.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setSensors', undefined);
        }
    },

    async loadSensorStations( {commit}, payload ){
        const { organization_ids } = payload;
        try {
            const response = await loadSensorStations({ organization_ids });
            commit('setSensorStations', response.data);
        } catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações dos sensores das estações.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setSensorStations', undefined);
        }
    },

    async loadOperations( {commit}, payload ){
        const { operation_ids } = payload;
        try{
            const response = await loadOperations({ operation_ids });
            commit('setOperations', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações das operações.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setOperations', undefined);
        }
    },

    async loadOperationSensorStation( {commit}, payload ){
        const { summary_operation } = payload;
        try{
            const response = await loadOperationSensorStation({ summary_operation });
            commit('setOperationSensorStation', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações das operações dos sensores.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setOperationSensorStation', undefined);
        }
    },

    async loadHourlySummary( {commit}, payload ){
        try{
            const response = await loadHourlySummary({ ...payload });
            commit('setHourlySummary', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações do sumário horário.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setHourlySummary', undefined);
        }
    },

    async loadDailySummary( {commit}, payload ){
        try{
            const response = await loadDailySummary({ ...payload });
            commit('setDailySummary', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações do sumário diário.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setDailySummary', undefined);
        }
    },

    async loadCurrentQuotaChart( {commit}, payload ){
        try{
            const response = await loadCurrentQuotaChart({ ...payload });
            commit('setCurrentQuotaChart', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações do gráfico do nível atual.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setCurrentQuotaChart', undefined);
        }
    },

    async loadCurrentQuota( {commit}, payload ){
        try{
            const response = await loadCurrentQuota({ ...payload });
            commit('setCurrentQuota', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações do nível atual.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setCurrentQuota', undefined);
        }
    },

    async loadVolume( {commit}, payload ){
        try{
            const response = await loadVolume({ ...payload });
            commit('setVolume', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações de volume.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setVolume', undefined);
        }
    },

    async loadVolumeSaic( {commit}, payload ){
        try{
            const response = await loadVolume({ ...payload });
            commit('setVolumeSaic', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações de volume SAIC.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setVolumeSaic', undefined);
        }
    },

    async loadMonthlySummary( {commit}, payload ){
        try{
            const response = await loadMonthlySummary({ ...payload });
            commit('setMonthlySummary', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações de sumário mensal.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setMonthlySummary', undefined);
        }
    },

    async loadQualities( {commit}, payload ){
        try{
            const response = await loadQualities({ ...payload });
            commit('setQualities', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações das qualidades.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setQualities', undefined);
        }
    },

    async loadReadingsData( {commit}, payload ){
        try{
            const response = await loadReadingsData({ ...payload });
            commit('setReadingsData', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações das leituras.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setReadingsData', undefined);
        }
    },

    async loadOrganizations( {commit}, payload ){
        try{
            const response = await loadOrganizations({ ...payload });
            commit('setOrganizations', response.data);
        }catch(error){
            Vue.$toast.open({
                message: `Não foi possível carregar as informações das organizações.`,
                type: "error",
                duration: 5000,
                dismissible: true
            });
            commit('setOrganizations', undefined);
        }
    },

  async loadQuotas( {commit}, payload ){
    try{
      const response = await loadQuotas({ ...payload });
      commit('setQuotas', response.data);
    }catch(error){
        Vue.$toast.open({
            message: `Não foi possível carregar as informações dos níveis.`,
            type: "error",
            duration: 5000,
            dismissible: true
        });
      commit('setQuotas', undefined);
    }
  },

};

const getters = {
    stations: (state) => state.stations,
    sensors: (state) => state.sensors,
    sensorStations: (state) => state.sensorStations,
    operations: (state) => state.operations,
    operationSensorStations: (state) => state.operationSensorStations,
    hourlySummary: (state) => state.hourlySummary,
    dailySummary: (state) => state.dailySummary,
    monthlySummary: (state) => state.monthlySummary,
    qualities: (state) => state.qualities,
    readignsData: (state) => state.readignsData,
    currentQuota: (state) => state.currentQuota,
    currentQuotaChart: (state) => state.currentQuotaChart,
    volume: (state) => state.volume,
    volumeSaic: (state) => state.volumeSaic,
    organizations: (state) => state.organizations,
    quotas: (state) => state.quotas,
};

export default {
    state,
    mutations,
    actions,
    getters
}
